import BaseRepository from '@/repositories/base/BaseRepository'

class HomeRepository extends BaseRepository {
	// 获取广告活动种类相关契约
	getActivityKinds(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/goldBooth/getActivityKinds',
			data: params,
		})
	}

	//查询字符串配置
	queryStringConfiguration(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/configuration/query-string-configuration',
			data: params,
		})
	}

	// 获取顶部banner图片接口
	getPuffImage(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/goldBooth/getPuffImage',
			data: params,
		})
	}

	// 关闭高峰日引导
	closeRemind(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/peak-day-setting/close-remind',
			data: params,
		})
	}

	// 是否展示高峰日引导弹窗
	steerPopUps(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/peak-day-setting/steer-pop-ups',
			data: params,
		})
	}

	// 创建留资信息
	saveRetainedCapital(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/hotel-retained-capital/save-retained-capital',
			data: params,
		})
	}

	// 留资信息列表
	queryRetainedCapitalList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/hotel-retained-capital/query-retained-capital-list',
			data: params,
		})
	}

	//查询调查问卷
	getSurveyInfo(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/survey/get-survey-info',
			data: params,
		})
	}
	//保存调查问卷内容
	saveSurveyContent(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/survey/save-survey-content',
			data: params,
		})
	}

	// 活动详情
	getPromotionHotelDetail(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/promotion-hotel/detail',
			data: params,
		})
	}

	// 活动报名
	applyPromotionHotel(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/promotion-hotel/apply',
			data: params,
		})
	}
}

export default HomeRepository
